import {ArrowBackIcon, Box, Button, StopCircleOutlinedIcon, styled} from '../../../ui-library';


export const BackIcon = styled(ArrowBackIcon)`
    font-size: 18px;
`;
export const BackBtn = styled(Button)`
    ${({ theme }) => theme.typography.button};
    font-size: 12px;
    display: flex;
    flex-direction: row;
    color:${({ theme }) => theme.palette.primary.main};
    cursor: pointer;
    width: fit-content;
`;

export const PageBox = styled(Box)`
    display: flex;
    flex-direction: column;
    padding: 40px 179px 114px 179px;
`;

export const TabsBox = styled(Box)`
    margin-top: 30px;
    width: 100%;
`;

export const StopBtn = styled(Button)`
    ${({ theme }) => theme.typography.button};
    width: 108px;
    height: 42px;
    font-size: 16px;
    padding: 8px 22px;
`;

export const StopIcon = styled(StopCircleOutlinedIcon)`
    font-size: 20px;
`;

export const ButtonsBox = styled(Box)`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    min-width: 900px;
`;

export const LoadingBox = styled(Box)`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 800px;
    width: 100%;
`;
